import { HttpMethod, type IHttpClient } from '@/shared/contracts/http-client.contract';

import { COMPLETION_ENDPOINT, EMAIL_ENDPOINT, type ProfileCompletion } from '../types';

/** PRAT-161: o que falta no perfil e a recompensa ligada (pratiGO e da loja). */
export class GetProfileCompletionUseCase {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute(input: { slug?: string }): Promise<ProfileCompletion> {
    return this.client.sendRequest<ProfileCompletion, void>({
      method: HttpMethod.GET,
      endpoint: COMPLETION_ENDPOINT,
      params: input.slug ? { slug: input.slug } : undefined,
    });
  }
}

/** PRAT-161: manda o link de confirmação; o e-mail só vale depois do clique. */
export class RequestEmailConfirmationUseCase {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute(input: { email: string; slug?: string }): Promise<ProfileCompletion> {
    return this.client.sendRequest<ProfileCompletion, { email: string; slug?: string }>({
      method: HttpMethod.POST,
      endpoint: EMAIL_ENDPOINT,
      body: { email: input.email.trim(), ...(input.slug ? { slug: input.slug } : {}) },
    });
  }
}
